import {Button, Col, Popconfirm, Table} from "antd";
import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import Link from "antd/es/typography/Link";
import {DeleteOutlined, EditOutlined, FileTextOutlined, SelectOutlined} from "@ant-design/icons";
import {Skeleton} from "antd/es";

export function TableView(props) {
    const [data, setData] = useState([])
    const [selectedData, setSelectedData] = useState([])
    const [loadingData, setLoadingData] = useState(false)
    const [deleteConfirmShow, setDeleteConfirmShow] = useState({})

    useEffect(() => {
        setData(props.data)
        setSelectedData(props.selectedData)
        setLoadingData(props.loading ?? false)
    }, [props])

    let columns = props.columns ?? []
    const actionColumns = [
        {
            title: 'Action',
            key: 'operation',
            width: props.actionWidth ?? 320,
            render: (text, record) => (
                <Col key={'action_default_' + record.id}>
                    {props.getEditUrl ? (
                        <Button
                            type={'link'}
                            key={'edit_' + record.id}
                            style={{marginRight: 6, color: ' #0531ad'}}
                            href={props.getEditUrl(record)}
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            {' '}
                            <EditOutlined/>
                        </Button>
                    ) : null}
                    {props.getDetailsUrl ? (
                        <Link
                            style={{marginRight: 6, color: ' #0531ad'}}
                            href={props.getDetailsUrl(record)}
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            {' '}
                            <FileTextOutlined/>
                        </Link>
                    ) : null}
                    {props.getOpenUrl ? (
                        <Link
                            key={'open_' + record.id}
                            style={{marginRight: 6, color: ' #0531ad'}}
                            href={props.getOpenUrl(record)}
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            {' '}
                            <SelectOutlined rotate={90}/>
                        </Link>
                    ) : null}
                    {props.deleteFunc ? (
                        <Popconfirm
                            key={'delete_' + record.id}
                            open={deleteConfirmShow[record.id]}
                            title='Are you sure you want to permanently delete it?'
                            onConfirm={() => {props.deleteFunc(record.id);
                                const newData = deleteConfirmShow
                                newData[record.id] = false
                                setDeleteConfirmShow(newData)
                            }}
                            onCancel={() => {
                                const newData = deleteConfirmShow
                                newData[record.id] = false
                                setDeleteConfirmShow(newData)
                            }}
                        >
                            <DeleteOutlined
                                style={{marginLeft: 6, color: 'indianred'}}
                                onClick={() => {
                                    const newData = deleteConfirmShow
                                    newData[record.id] = true
                                    setDeleteConfirmShow(newData)
                                }}
                            />
                        </Popconfirm>
                    ) : null}
                </Col>
            )
        }
    ]
    if(props.getEditUrl || props.getDetailsUrl || props.getOpenUrl || props.deleteFunc)
        columns = columns.concat(actionColumns)

    const dataSource = []
    data?.forEach((item) => {
        let dict = {key: item.id}
        columns.forEach((column) => {
            if (column.dataIndex) {
                let key = column.dataIndex
                dict[key] = item[key]
            }
        })
        dataSource.push(dict)
    })
     const onSelectChange = (newSelectedRowKeys) => {

     const selectedItems = newSelectedRowKeys.map((key)=>{
           const checkedList = data.filter((d)=>(d.id?.toString() === key.toString()))
           return checkedList[0]
       })
       if(props.selectArrayFunc)
        props.selectArrayFunc(selectedItems)
    };

    const selectedKeys = selectedData?.map((data)=>(data.id))
    const rowSelection = {
        selectedRowKeys: selectedKeys,
        onChange: onSelectChange,
    };

    if(loadingData) {
        return <>
            <Skeleton/>
            <Skeleton/>
            <Skeleton/>
            <Skeleton/>
            <Skeleton/>
        </>
    }

    return (
        <>
            <Table rowSelection={rowSelection} scroll={{x: props.tableWidth ?? 1200}} pagination={false}
                   columns={columns.filter(item => !item.hidden)}
                   dataSource={dataSource}/>
        </>
    )
}

TableView.defaultProps = {
    data: [],
    selectedData: [],
    columns: [],
    tableWidth: 1200,
    selectArrayFunc: null
}

TableView.propTypes = {
    data: PropTypes.array,
    selectedData: PropTypes.array,
    columns: PropTypes.array,
    tableWidth: PropTypes.number,
    selectArrayFunc: PropTypes.func,
}

export default TableView